import { PercentageCellEditor } from './PercentageCellInnerComponents'
import { DataGridCell } from './types'

export const PercentageCell: DataGridCell = {
    provideEditor: PercentageCellEditor,
}
